import type {Stripe} from '@stripe/stripe-js';
import {loadStripe} from '@stripe/stripe-js/pure';

let stripePromise: Promise<Stripe | null> | null = null;

/**
 * Imported from `/pure` so the Stripe script is fetched on the first checkout rather than on import.
 * The plain entry point injects it as an import side effect, which put `window.Stripe` on every page
 * carrying this bundle — and the legacy dialog reads that global to decide whether it still has to
 * load and construct its own Stripe instance, so it would skip the step and run without one.
 */
export const getStripePromise = (): Promise<Stripe | null> => {
  stripePromise ??= loadStripe(window.PMW.STRIPE_PUBLIC_KEY);
  return stripePromise;
};
